import React from 'react';
import { Text } from '@react-three/drei';

function Inverter({ position, size, onHover, component, onClick }) {
  const [width, height, depth] = size;
  return (
    <group position={position}>
      <mesh
        onPointerOver={() => onHover(component.name)}
        onPointerOut={() => onHover(null)}
        onClick={() => onClick(component)}
        castShadow
        receiveShadow
      >
        <boxGeometry args={[width, height, depth]} />
        <meshLambertMaterial color='#059669' />
      </mesh>

      <mesh position={[0, 0, depth / 2 + 0.01]}>
        <planeGeometry args={[width * 0.9, height * 0.9]} />
        <meshLambertMaterial color='#047857' />
      </mesh>

      <mesh position={[0, height / 4, depth / 2 + 0.02]}>
        <planeGeometry args={[width * 0.4, height * 0.2]} />
        <meshLambertMaterial color='#000000' />
      </mesh>

      <mesh position={[-width / 4, -height / 4, depth / 2 + 0.02]}>
        <sphereGeometry args={[0.1]} />
        <meshBasicMaterial color='#22c55e' />
      </mesh>
      <mesh position={[width / 4, -height / 4, depth / 2 + 0.02]}>
        <sphereGeometry args={[0.1]} />
        <meshBasicMaterial color='#ef4444' />
      </mesh>

      {Array.from({ length: 3 }).map((_, i) => (
        <mesh key={i} position={[0, -height / 3 + i * 0.2, depth / 2 + 0.01]}>
          <boxGeometry args={[width * 0.6, 0.05, 0.02]} />
          <meshLambertMaterial color='#374151' />
        </mesh>
      ))}

      <mesh position={[-width / 2 - 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height * 0.8, depth * 0.3]} />
        <meshLambertMaterial color='#6b7280' />
      </mesh>
      <mesh position={[width / 2 + 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height * 0.8, depth * 0.3]} />
        <meshLambertMaterial color='#6b7280' />
      </mesh>

      <group position={[2, height + 3, 0]}>
        {/* First line - BIG FONT */}
        <Text
          fontSize={1.3}
          color='black'
          anchorX='right'
          anchorY='bottom'
          outlineColor='#000000ff'
          outlineWidth={0.01}
          fontWeight={700}
        >
          {component.name}
        </Text>

        {/* Next 2 lines - SMALL FONT only if value exists */}
        {(component.details?.Brand_name ||
          component.details?.Quantity ||
          component.details?.Specification) && (
          <Text fontSize={0.9} color='black' anchorX='center' anchorY='top'>
            {`${component.details?.Brand_name || ''}\nx${component.details?.Quantity || '0'}\n${component.details?.Specification || ''}`}
          </Text>
        )}
      </group>
    </group>
  );
}

export default Inverter;
